import styled from 'styled-components';
import {
  Card as card,
  CardHeader as cardHeader,
  CardBody as cardBody,
} from 'reactstrap';
import { H3 } from '../Heading';

const Card = styled(card)`
  margin: ${({ $withoutMargin }) => ($withoutMargin ? '0' : '10px 0')};
  border-color: ${({ theme, border }) =>
    (typeof border === 'string' && border) ||
    theme.colors.semantic.border.default};

  background: ${props =>
    props.background || props.theme.colors.semantic.surface.card};
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

const CardHeader = styled(cardHeader)`
  padding: 8px;
  margin: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.semantic.border.default} !important;

  svg {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }
`;

const CardBody = styled(cardBody)`
  padding: 16px;
  height: 100%;
`;

const CardTitle = styled(H3)`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

const CardAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
`;

export default Card;

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Title = CardTitle;
Card.Action = CardAction;
